export class CoursewareServer {
  public static defaults = 'beta';
  public static envs = {
    development: 'https://courseware-server.beta.saybot.net',
    beta: 'https://courseware-server.beta.saybot.net',
    staging: 'https://courseware-server.staging.saybot.net',
    production: 'https://courseware-api.alo7.com',
  };

  public static get(inKey) {
    const envs = this.envs;
    return envs[inKey] || envs[this.defaults];
  }
}
